import { Page } from 'corso-admin-ui';
import { useState } from 'react';
import SearchTable from '~/components/searchTable/SearchTable';
import useIsCorsoAdmin from '~/hooks/useIsCorsoAdmin';
import UploadProducts from './components/UploadProducts';

export default function ProductsTablePage() {
  const [showUploadProducts, setShowUploadProducts] = useState(false);
  const isCorsoAdmin = useIsCorsoAdmin();

  return (
    <Page
      title="Products"
      size="fullWidth"
      primaryAction={
        isCorsoAdmin
          ? {
              content: 'Upload Products',
              onAction: () => setShowUploadProducts(true),
            }
          : undefined
      }
    >
      <SearchTable />
      <UploadProducts
        show={showUploadProducts}
        onClose={() => setShowUploadProducts(false)}
      />
    </Page>
  );
}
